export default {
  SalaryAccounting: 'Hạch toán chi phí lương, BH, KPCĐ',
  InsuaranceAccounting: 'Hạch toán chi phí bảo hiểm',
};
